<script>
import constant from "@/configs/constant";
import systemCode from "@/mixins/systemCode";

export default {
  name: "schedule_regular_interval_information_by_sale",
  mixins: [systemCode],
  props: {
    workReservation: {
      type: Object,
      required: true
    },
    regularInformation: {
      type: Object,
      required: true
    },
  },
  methods: {
    regularly_date_formatted(date) {
      const dateFormatted = this.$options.filters.longDateWithJP(date);
      const dayOfWeek = this.$options.filters.longDate(date, 'day');

      return `${dateFormatted}（${dayOfWeek}）`
    },
    getDayOfTimeZone() {
      const startTime = this.regularInformation.start_time;
      const endTime = this.regularInformation.end_time;

      return `時間帯：<div class="me-2">${startTime}</div>～<div class="ms-2">${endTime}</div`;
    },
  },
  computed: {
    zz_regularly_reservation_intervals() {
      return (
        this.$store.getters["options/options_tables"]
          .zz_regularly_reservation_intervals ?? []
      );
    },
    days_of_the_week() {
      return constant.DAY_OF_WEEKS;
    },
  },
}
</script>

<template>
  <div class="d-flex flex-column">
    <div class="mb-1">
      <span>開始年月日：</span>
      <span>{{regularly_date_formatted(workReservation.regularly_reservation_start_date)}}</span>
      <span>～</span>
      <span class="ms-2">終了年月日：</span>
      <span>{{regularly_date_formatted(workReservation.regularly_reservation_end_date)}}</span>
    </div>
    <div>
      <div class="d-flex mt-0 gap-1" v-html="getDayOfTimeZone()"></div>
      <div class="mt-1">
        <b-form-radio-group
          disabled
          v-if="workReservation.zz_regularly_reservation_interval_id"
          v-model="workReservation.zz_regularly_reservation_interval_id"
          class="d-inline-flex"
        >
          <b-form-radio
            v-for="item in zz_regularly_reservation_intervals"
            :key="item.id"
            :value="item.id"
            class="me-4"
          >
            {{ item.regularly_reservation_interval }}
            <span
              v-if="workReservation.regularly_reservation_date_of_month && item.regularly_reservation_interval == '毎月'"
              class="ms-1"
            >
              {{ workReservation.regularly_reservation_date_of_month }}日
            </span>
          </b-form-radio>
        </b-form-radio-group>
        <b-form-radio-group
          v-else
          disabled
          class="d-inline-flex"
        >
          <b-form-radio
            v-for="item in zz_regularly_reservation_intervals"
            :key="item.id"
            :value="item.id"
            class="me-4"
          >
            {{ item.regularly_reservation_interval }}
          </b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="mt-1">
        <b-form-checkbox-group
          disabled
          v-if="workReservation.regularly_reservation_day_of_week"
          v-model="workReservation.regularly_reservation_day_of_week"
          :options="days_of_the_week"
          class="d-inline-flex gap-4"
        >
        </b-form-checkbox-group>
        <b-form-checkbox-group
          disabled
          v-else
          :options="days_of_the_week"
          class="d-inline-flex gap-4"
        >
        </b-form-checkbox-group>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
